/**
 * Route for `advertiser-macros`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AdvertiserMacrosPage } from "../features/advertiser-macros/AdvertiserMacrosPage";

export const advertiserMacrosRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/advertiser-macros",
	component: AdvertiserMacrosPage,
});

export default advertiserMacrosRoute;
